/**
 * @generated SignedSource<<e96d6ebec8e41a142f68dc15ef77453c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksNewsAgendaTopic$data = {
  readonly newsAgenda: {
    readonly endDate: number | null | undefined;
    readonly newsAgendaOptions: ReadonlyArray<string>;
    readonly startDate: number | null | undefined;
    readonly time: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "hooksNewsAgendaTopic";
};
export type hooksNewsAgendaTopic$key = {
  readonly " $data"?: hooksNewsAgendaTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksNewsAgendaTopic">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksNewsAgendaTopic",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NewsAgenda",
      "kind": "LinkedField",
      "name": "newsAgenda",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "time",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "newsAgendaOptions",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Topic",
  "abstractKey": null
};

(node as any).hash = "e756e74e928242964969d52a7534a98d";

export default node;
